"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderSelect = void 0;
const react_1 = __importStar(require("react"));
const react_device_detect_1 = require("react-device-detect");
const use_theme_1 = __importDefault(require("../hooks/use-theme"));
const tailwind_1 = __importDefault(require("../utils/tailwind"));
const styles = (0, tailwind_1.default)({
    button: `
    tw-flex
    tw-flex-row
    tw-items-center
    tw-text-left
    tw-py-1.5
    tw-pl-2
    tw-pr-2
    ${react_device_detect_1.isMobile ? 'tw-w-full' : 'tw-w-11/12'}
    tw-transition
    tw-rounded-md
    focus:tw-outline-none
    tw-will-change-transform
    tw-scale-100
    active:tw-scale-95`,
    rowContainer: `
    tw-flex 
    tw-flex-shrink-0 
    tw-mr-4 
    md:tw-mr-5`,
    iconContainer: `
    tw-my-auto 
    tw-rounded
    tw-p-0.5
    ${react_device_detect_1.isMobile ? 'tw-h-10 tw-w-10' : 'tw-h-7 tw-w-7'}`,
    icon: `
    tw-h-full 
    tw-w-full`,
    name: `
    tw-font-medium 
    tw-text-sm
    tw-antialiased`,
    description: `
    tw-text-sm`,
});
const ProviderSelect = ({ provider, selected, onClick, }) => {
    const theme = (0, use_theme_1.default)();
    const [hover, setHover] = (0, react_1.useState)(false);
    return (react_1.default.createElement("button", { className: styles.button, style: {
            background: selected ? theme.primary : hover ? theme.muted : '',
            color: selected ? theme.secondary : theme.text,
        }, onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false), onClick: onClick },
        react_1.default.createElement("div", { className: styles.rowContainer },
            react_1.default.createElement("span", { className: styles.iconContainer, style: { background: theme.muted } }, typeof provider.icon === 'string' ? (react_1.default.createElement("img", { src: provider.icon, alt: `${provider.name} logo`, className: styles.icon })) : (react_1.default.createElement(provider.icon, { className: styles.icon })))),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles.name, style: {
                    color: selected ? theme.secondary : theme.text,
                } }, provider.name),
            react_device_detect_1.isMobile && (react_1.default.createElement("div", { className: styles.description, style: { color: theme.textSecondary } }, provider.description)))));
};
exports.ProviderSelect = ProviderSelect;
//# sourceMappingURL=provider-select.js.map